<script type="text/javascript">
export default{
    methods: {
        error() {
            $('#message').removeClass('hidden')
                setTimeout(() => {
                    $('#message').addClass('hidden')
                }, 5000);
                $('#'+this.name+' button').prop("disabled", false)
        },

        save() {
            this.$store.dispatch( this.name +'/save' ).then(response => {
                $('#'+this.name+' button').prop("disabled", false);
                $('#success').removeClass('hidden')
                setTimeout(() => {
                    $('#success').addClass('hidden')
                }, 2000)
            }, error => {
                this.error(error.response.data.message)
            })
        },
        destroy() {
            if(confirm('Sicuro di voler eliminare l\'elemento?')){
                this.$store.dispatch( this.name +'/destroy' ).then( response => {
                    this.$router.go(-1)
                }, error => {
                    this.message = error.response.data.message
                    this.error()
                })
            }
        },

    },

    mounted(){
        this.$store.dispatch( this.name + '/reset' )
    },

    updated() {
        $('body').getNiceScroll().resize()
    },

}
</script>